<template>
    <ai-form-text-box-dictionary
        ref="tboxGrpTabRef"
        title="Где менял"
        placeholder="Тематические группы и таблицы"
        :field-key="meta.fieldKey"
        :field-name-id="meta.fieldKey"
        :field-name-text="meta.fieldText"
        :key-expr="meta.keyExpr"
        :value-expr="meta.keyExpr"
        :display-expr="meta.displayExpr"
        :data-source="dict"
        :custom-buttons="customButtons"
        :need-modified-class="false"
        @popup-shown="popupShown"
    >
        <grp-tab-tree ref="grpTabTreeRef" :meta="meta" @where-change-active="onSelectTreeItem" />

        <dx-toolbar-item location="after" toolbar="bottom">
            <dx-button text="Выбрать" @click="chooseItem" />
        </dx-toolbar-item>

        <dx-toolbar-item location="after" toolbar="bottom">
            <dx-button text="Отмена" @click="hide" />
        </dx-toolbar-item>
    </ai-form-text-box-dictionary>
</template>

<script setup>
import { ref, computed, reactive, inject, onMounted } from 'vue';

import { DxButton } from 'devextreme-vue/button';
import { DxToolbarItem } from 'devextreme-vue/popup';

import AiFormTextBoxDictionary from '@/components/card-component/ai-form-text-box-dictionary.vue';
import GrpTabTree from '@/views/history/history-card/components/grp-tab-tree.vue';

const grpTabTreeRef = ref(null);
const tboxGrpTabRef = ref(null);
const popupInstance = ref(null);

const userData = inject('userData');
const conditions = inject('conditions');

const meta = {
    // используется только в input, в popup не используется
    fieldKey: 'where_id',
    fieldText: 'where_name',

    // используется в input и popup
    keyExpr: 'key',
    displayExpr: 'name',
    parentIdExpr: 'parent_id',

    // используется только в popup
    searchHint: null,
    valueChangeEvent: 'keyup',
    rootValue: null,
    dataStructure: 'plain',
    selectByClick: true,
    expandEvent: 'dblclick',
    selectionMode: 'single',
    itemTemplate: 'items-template',
};

// активный элемент в дереве
const lastActive = {
    id: null,
    name: null,
};

const dict = computed(() => {
    let res = [];
    if (conditions.value) {
        res = [
            {
                key: conditions.value.where_id,
                name: conditions.value.where_name,
            },
        ];
    }
    return res;
});

const customButtons = reactive([
    {
        name: 'clearButton',
        options: {
            visible: true,
            disabled: false,
            icon: 'close',
            onClick: async () => {
                userData.value.where_id = null;
                userData.value.where_name = null;
            },
        },
    },
]);

onMounted(() => {
    popupInstance.value = tboxGrpTabRef.value?.popupInstance;
});

const hide = () => {
    popupInstance.value.instance().hide();
};

// клик на элемент дерева
const onSelectTreeItem = itemData => {
    lastActive.id = itemData.key;
    // lastActive.name = itemData.name;
    lastActive.name = itemData.info ?? itemData.name;
};

// клик на кнопку "Выбрать" в popup
const chooseItem = async () => {
    conditions.value = { ...conditions.value, ...{ where_id: lastActive.id, where_name: lastActive.name } };
    userData.value = conditions.value;
    hide();
};

const popupShown = () => {
    if (userData.value?.where_id) {
        grpTabTreeRef.value.selectNode(userData.value.where_id);
    }
};

</script>
